"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dispatchOpen_1 = require("../../Shared/Util/dispatchOpen");
function handleHeadClick(e, _a) {
    var state = _a.state, actions = _a.actions, dom = _a.dom, config = _a.config;
    if (state.isUseNativeMode)
        return;
    e.stopPropagation();
    if (state.isClosed) {
        dispatchOpen_1.default(actions, config, dom);
        dom.select.focus();
    }
    else {
        actions.close();
    }
}
exports.default = handleHeadClick;
//# sourceMappingURL=handleHeadClick.js.map